import { render, staticRenderFns } from "./quotation-form.vue?vue&type=template&id=a659aa50"
import script from "./quotation-form.vue?vue&type=script&lang=js"
export * from "./quotation-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/Resourced/Resourced/Frontend-old/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a659aa50')) {
      api.createRecord('a659aa50', component.options)
    } else {
      api.reload('a659aa50', component.options)
    }
    module.hot.accept("./quotation-form.vue?vue&type=template&id=a659aa50", function () {
      api.rerender('a659aa50', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/pages/quotation-form.vue"
export default component.exports